/** @jsxImportSource theme-ui */
import { Container, Heading } from 'theme-ui';
import CreateTicket from '@/containers/tickets/CreateTicket';

const CreateTicketPage = () => {
    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Create Ticket
            </Heading>
            <CreateTicket />
        </Container>
    );
};

export default CreateTicketPage;
